module.exports = __webpack_public_path__ + "static/img/尚云互联.d08e055.png";


//////////////////
// WEBPACK FOOTER
// ./static/meiti-index/尚云互联.png
// module id = h7Xo
// module chunks = 1